// src/empty.tsx
import React from "react";
var Empty = props => {
  return /* @__PURE__ */React.createElement("div", null, `组件 ${props.widget} 不存在`);
};
var empty_default = Empty;
export { empty_default as default };